// extracted by mini-css-extract-plugin
export default {"container":"HistoryScreen_container__xuZjD"};